import { styling } from '../core/styling.js';

const backgroundColor = styling({
    $backgroundColor: {
        type: 'string',
        properties: ['backgroundColor'],
    },
});

export { backgroundColor };
//# sourceMappingURL=backgroundColor.js.map
